import { Divider, List, Upload } from 'antd';
import styled from 'styled-components';
const { Dragger } = Upload;
export const FloorManageWrapper = styled.div `
  display: flex;
  height: 100%;
  overflow: hidden;
  width: 100%;
`;
export const Buildings = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: content-box;
  width: 320px;
  border-right: 1px solid hsla(0, 0%, 0%, 0.07);
  z-index: 21;
  background-color: hsl(
    var(--ue-base-pressed-color_h, 0),
    var(--ue-base-pressed-color_s, 0%),
    var(--ue-base-pressed-color_l, 95%),
    var(--ue-base-pressed-color_t, 1)
  );
`;
export const Floors = styled.div `
  width: calc(100% - 250px);
  display: flex;
  flex-direction: column;
  height: 100%;
`;
export const BuildingsInner = styled.div `
  padding: calc(calc(5 * 1px) * 2);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 12px;
  flex: 1;
  overflow: auto;
`;
export const FloorsInner = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: calc(calc(5 * 1px) * 2);
  height: 100%;
  overflow: auto;
`;
export const SimpleUploadCard = styled.div `
  display: flex;
  align-items: center;
  flex-direction: column;
  flex: 1;
  width: 100%;
  min-width: 100%;

  cursor: pointer;
  padding: calc(5 * 1px * 3) calc(5 * 1px * 2);
  border-radius: 15px;
  box-shadow: 0 1px 3px 0 hsla(0, 0%, 0%, 0.1), 0 0 0 1px hsla(0, 0%, 0%, 0.07);
  background-color: hsla(0, 0%, 100%, 1);
  box-sizing: border-box;
`;
export const FileUploader = styled(Dragger) `
  --bc-color-fill-alter: transparent;
  --bc-color-border: hsla(0, 0%, 33.33%, calc(1 - 0.6));
  --bc-border-radius-lg: 15px;
  --bc-line-width: 2px;
  min-height: 350px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  flex: 1 1 auto;
  width: 100%;
  height: 100%;

  transition: all 0.2s linear;
  box-sizing: border-box;
  height: 165px;
  cursor: pointer;

  span {
    margin-left: auto;
    margin-right: auto;
    display: flex;
    height: calc(calc(5 * 1px) * 4);
    width: calc(calc(5 * 1px) * 4);
    min-width: calc(calc(5 * 1px) * 4);
    color: hsla(0, 0%, 33.33%, calc(1 - 0.2));
    height: calc(calc(calc(5 * 1px) * 4) * 2);
    width: calc(calc(calc(5 * 1px) * 4) * 2);
    transition: all 0.2s linear;
  }
  h5 {
    text-align: center;
    font-size: 14px;
    line-height: calc(14px + 6px);
    color: #545454;
    margin: 0;
    margin-top: calc(5 * 1px);
    margin-bottom: calc(5 * 1px);
  }
  p {
    text-align: center;
    font-size: calc(14px - 2px);
    line-height: 14px;
    color: hsla(0, 0%, 33.33%, calc(1 - 0.15));
    margin: 0;
  }
  /* 
  svg {
    path {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
  h3 {
    font-size: 20px;
    font-weight: 800;
    margin-top: 12px;
    margin-bottom: 1px;
  }

  p {
    color: ${({ theme }) => theme.textEmphasis.muted};
    margin: 0;
  } */
`;
export const BuildingHeader = styled.div `
  display: block;
  position: relative;
  min-height: 70px;
  background: hsla(0, 0%, 0%, 0.07);
  border-radius: 15px 15px 0 0;
  font-size: calc(14px - 2px);
  line-height: 14px;
  color: hsla(0, 0%, 33.33%, calc(1 - 0.15));
  text-align: center;
  overflow: hidden;
  padding: 15px 10px 30px;
  margin-bottom: -30px;

  h3 {
    font-size: calc(calc(14px - 5px) * 2);
    font-weight: 600;
    color: hsla(0, 0%, 33.33%, 1);
    margin: 0;
  }
`;
export const BuildingList = styled(List) `
  .bc-list-items {
    display: flex;
    flex-direction: column;
    padding: calc(calc(calc(5 * 1px) * 3) * 2) calc(calc(5 * 1px) * 2) calc(calc(5 * 1px) * 4);
    border-radius: 12px;
    box-shadow: 0 1px 3px 0 hsla(0, 0%, 0%, 0.1), 0 0 0 1px hsla(0, 0%, 0%, 0.07);
    background-color: hsla(0, 0%, 100%, 1);
    flex: 1;
    gap: 8px;
    .bc-list-item {
      user-select: none;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
      flex-direction: row;
      flex: 1;
      cursor: pointer;
      /* padding: calc(calc(calc(5 * 1px) * 3) * 2) calc(calc(5 * 1px) * 2) calc(calc(5 * 1px) * 4); */
      border-radius: 12px;
      /* box-shadow: 0 1px 3px 0 hsla(0, 0%, 0%, 0.1), 0 0 0 1px hsla(0, 0%, 0%, 0.07); */
      background-color: hsla(0, 0%, 100%, 1);
      padding: calc(calc(5 * 1px) * 2);
      background-color: hsla(
        var(--ue-option-panel-background-color_h, 0),
        var(--ue-option-panel-background-color_s, 0%),
        calc(var(--ue-option-panel-background-color_l, 100%) - 9%),
        calc(var(--ue-option-panel-background-color_t, 1) - 0.1)
      );
      box-sizing: border-box;
      border-block-end: none;

      .ic-sec {
        color: hsla(0, 0%, 33.33%, calc(1 - 0.15));
      }
      h5 {
        margin: 0;
        line-height: 24px;
        color: hsla(0, 0%, 13%, 1);
        font-size: 14px;
        line-height: normal;
        flex: 1;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: center;
        gap: 2px;
        span {
          color: hsl(0deg 0% 24.56% / 64%);
          font-size: 12px;
        }
      }
    }
    .bc-list-item-action {
      margin-inline-start: 0;
      li {
        color: hsla(0, 0%, 33.33%, calc(1 - 0.15));

        padding: 0;
      }
    }
  }
`;
export const BuildingItem = styled(List.Item) `
  box-shadow: ${({ Selected }) => (Selected ? `inset 0 0 0 2px hsla(129, 60%, 50%, 1)` : 'none')} !important;

  /* display: flex;
  cursor: pointer;
  align-items: center;
  border-block-end: none !important;

 
  border-radius: ${({ theme }) => theme.borders.radius.sm};
  --bc-list-item-padding: ${({ theme }) => theme.space.space300}
    ${({ theme }) => theme.space.space200};
  --bc-line-width: 0;
  --bc-color-split: transparent;
  margin-bottom: ${({ theme }) => theme.space.space300};
  background-color: ${({ Selected, theme }) => (Selected ? theme.colors.primaryLight : '#fff')}; */

  /* min-height: calc(calc(5 * 1px) * 4); */
`;
export const FloorListCardOuter = styled.div ``;
export const FloorListCard = styled.div `
  display: flex;
  flex-direction: column;
  gap: 15px;
  /* padding: calc(calc(calc(5 * 1px) * 3) * 2) calc(calc(5 * 1px) * 2) calc(calc(5 * 1px) * 4); */
  /* border-radius: 15px;
  position: relative;
  box-shadow: 0 1px 3px 0 hsla(0, 0%, 0%, 0.1), 0 0 0 1px hsla(0, 0%, 0%, 0.07);
  background-color: hsla(0, 0%, 100%, 1); */
`;
export const RowHeader = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  h3 {
    font-size: 18px;
    font-weight: 600;
    color: hsla(0, 0%, 18%, 1);
    margin: 0;
  }
`;
export const FloorListCardHead = styled.div `
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  border-radius: 15px;
  position: relative;
  box-shadow: 0 1px 3px 0 hsla(0, 0%, 0%, 0.1), 0 0 0 1px hsla(0, 0%, 0%, 0.07);
  background-color: hsla(0, 0%, 100%, 1);
  padding: calc(calc(5 * 1px) * 3) calc(calc(5 * 1px) * 4) calc(calc(5 * 1px) * 3) calc(calc(5 * 1px) * 3);

  box-shadow: 0 1px 3px 0 hsla(0, 0%, 0%, 0.1), 0 0 0 1px hsla(0, 0%, 0%, 0.07);
  border-radius: 15px;
  /* border-bottom: 1px solid
    hsla(
      0,
      0%,
      0%,
      0.07
    ); */
`;
export const FloorListCardBody = styled.div `
  /* padding: calc(calc(5 * 1px) * 3); */
  box-shadow: 0 1px 3px 0 hsla(0, 0%, 0%, 0.1), 0 0 0 1px hsla(0, 0%, 0%, 0.07);
  border-radius: 15px;
  background: hsla(0, 0%, 0%, 0.07);
  border-radius: 15px;
  font-size: calc(14px - 2px);
  line-height: 14px;
`;
export const HiddenUpload = styled(Upload) `
  display: none;
`;
export const FloorListHeaderWrapper = styled.div `
  padding: calc(calc(5 * 1px) * 2);
  background-clip: padding-box;
  padding-right: calc(calc(5 * 1px) * 4);
  padding-left: calc(calc(5 * 1px) * 3);
  font-size: calc(14px - 2px);
  line-height: 14px;
  color: hsla(0, 0%, 33.33%, 1);
  font-weight: 400;
  text-align: left;
  /* border-bottom: 1px solid
    hsla(
      0,
      0%,
      0%,
      0.07
    ); */

  display: grid;
  grid-template-columns: 37px 1fr 53px;
  gap: 0.5rem;
  @media (min-width: 1000px) {
    gap: 2rem;
  }
`;
export const FloorListHeaderInner = styled.div `
  grid-template-rows: 1fr;
  -webkit-box-flex: 1;
  flex-grow: 1;
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: minmax(150px, 1fr) minmax(92px, 2fr);
  gap: 0.5rem;

  @media (min-width: 900px) {
    grid-template-rows: 1fr;
    grid-template-columns:
      minmax(150px, 3fr) minmax(150px, 1fr) minmax(150px, 2fr)
      minmax(92px, 1fr);
  }

  @media (min-width: 1000px) {
    gap: 2rem;
  }
`;
export const FloorListRowOuter = styled.div `
  display: grid;
  grid-template-columns: 37px 1fr 53px;
  gap: 0.5rem;
  -webkit-box-align: center;
  align-items: center;
  padding: 4px 12px;
  font-size: 14px;
  transition: 0.25s ease-out;
  user-select: none;
  ${({ border }) => (border ? '' : 'border-bottom: 1px solid hsla(0,0%,0%,0.07);')}

  &.dragging {
    outline: 1px solid #34a853;
    border-radius: 4px;
    margin: 0.5rem 0;

    & > * {
      visibility: hidden;
    }
  }

  @media (min-width: 1000px) {
    gap: 2rem;
  }
`;
export const FloorListRowInner = styled.div `
  -webkit-box-flex: 1;
  flex-grow: 1;
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: minmax(150px, 1fr) minmax(92px, 2fr);
  gap: 0.5rem;

  @media (min-width: 900px) {
    grid-template-rows: 1fr;
    grid-template-columns:
      minmax(150px, 3fr) minmax(150px, 1fr) minmax(150px, 2fr)
      minmax(92px, 1fr);
  }

  @media (min-width: 1000px) {
    gap: 2rem;
  }

  .bc-checkbox-inner {
    border-radius: 50px;
    border: var(--ue-border-width-1, 2px) solid hsla(129, 60%, 50%, 1);
    &:after {
      left: 50%;
      width: 8px;
      height: 8px;
      border: none;
      border-top: 0;
      border-inline-start: 0;
      transform: scale(0) translate(-50%, -50%);
      background: #fff;
      border-radius: 50px;
    }
  }

  .bc-checkbox-checked {
    .bc-checkbox-inner {
      background-color: hsla(129, 60%, 50%, 1);
      &:after {
        transform: scale(1) translate(-50%, -50%);
      }
    }
  }
`;
export const FloorListRowInnerDraggIcon = styled.div `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  height: calc(1.5em + 1.55rem + 2px);
  width: calc(1.5em + 1.55rem + 2px);
  line-height: 1;
  color: ${({ theme }) => theme.textEmphasis.muted};
`;
export const FileName = styled.span `
  font-size: 15px;
  font-weight: 500;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
export const SplitDivider = styled(Divider) `
  --bc-font-size-lg: 12px;
  --bc-color-split: ${({ theme }) => theme.textEmphasis.muted};
  .bc-divider-inner-text {
    background-color: #0d0d0d;
    color: #ffff;
    border-radius: 5px;
    padding: 2px 14px;
  }
`;
